import React, { useState, useEffect } from "react";
import Header from "../../Components/Header/header";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faEdit,
    faTrash
} from "@fortawesome/free-solid-svg-icons";
import Footer from "../../Components/Footer/footer";

import "./policy-list.css";

function PolicyList() {

    // =====================================================
    // STATES
    // =====================================================

    const [loadingPolicies, setLoadingPolicies] =
        useState(true);

    const [user, setUser] =
        useState(null);

    const [policies, setPolicies] =
        useState([]);

    const navigate = useNavigate();

    // =====================================================
    // GET USER
    // =====================================================

    useEffect(() => {

        const storedUser =
            localStorage.getItem("user");

        if (storedUser) {

            setUser(
                JSON.parse(storedUser)
            );

        }

    }, []);

    // =====================================================
    // FETCH POLICIES
    // =====================================================

    useEffect(() => {

        const fetchPolicies = async () => {

            try {

                const storedUser =
                    JSON.parse(
                        localStorage.getItem("user")
                    );

                if (
                    !storedUser ||
                    !storedUser.org_id
                ) {

                    console.error(
                        "User org_id missing!"
                    );

                    setPolicies([]);

                    return;
                }

                const orgId =
                    storedUser.org_id;

                const res = await fetch(
                    `/api/add_policy?org_id=${orgId}`
                );

                if (!res.ok) {

                    throw new Error(
                        `HTTP error! Status: ${res.status}`
                    );

                }

                const data =
                    await res.json();

                console.log(
                    "POLICIES:",
                    data
                );

                const filtered =
                    Array.isArray(data)
                        ? data.filter(
                              (p) =>
                                  p.org_id ===
                                  orgId
                          )
                        : [];

                setPolicies(filtered);

            } catch (err) {

                console.error(
                    "Error fetching policies:",
                    err
                );

                setPolicies([]);

            } finally {

                setLoadingPolicies(false);

            }
        };

        fetchPolicies();

    }, []);

    // =====================================================
    // DELETE POLICY
    // =====================================================

    const handleDeletePolicy =
        async (policyId) => {

            const confirmDelete =
                window.confirm(
                    "Are you sure you want to delete this policy?"
                );

            if (!confirmDelete)
                return;

            try {

                const res =
                    await fetch(
                        `/api/add_policy/${policyId}`,
                        {
                            method:
                                "DELETE",
                        }
                    );

                const data =
                    await res.json();

                if (data.success) {

                    setPolicies(
                        (prev) =>
                            prev.filter(
                                (p) =>
                                    p.policy_id !==
                                    policyId
                            )
                    );

                    alert(
                        "✅ Policy deleted successfully!"
                    );

                } else {

                    alert(
                        "⚠️ Failed to delete policy."
                    );

                }

            } catch (err) {

                console.error(
                    "Error deleting policy:",
                    err
                );

                alert(
                    "❌ Server error while deleting."
                );

            }
        };

    // =====================================================
    // EDIT POLICY
    // =====================================================

    const handleEditPolicy = async (policy) => {

    try {

        const res = await fetch(
            `/api/policy-details/${policy.policy_id}`
        );

        const data = await res.json();

        console.log("FULL POLICY DETAILS:", data);

        if (data.success) {

            navigate("/add-policy", {
                state: {
                    policy: data.policy,
                    isEdit: true
                }
            });

        } else {

            alert("Policy details not found");

        }

    } catch (err) {

        console.error("EDIT ERROR:", err);

        alert("Failed to fetch policy details");

    }

};

    return (

        <div className="hrdashboard-container">

            {/* SIDEBAR */}
            <aside className="sidebar">

                <Header />

            </aside>

            {/* MAIN CONTENT */}
            <main className="main-content">

                {/* CARD */}
                <div className="card">

                    {/* HEADER */}
                    <div className="policy-header">

                        <h2>
                            Policy List
                        </h2>

                        <button
                            className="add-btn"
                            onClick={() =>
                                navigate(
                                    "/add-policy"
                                )
                            }
                        >
                            Add Policy
                        </button>

                    </div>

                    {/* TABLE */}
                    <table className="policy-table">

                        {/* TABLE HEAD */}
                        <thead>

                            <tr>

                                <th>
                                    Policy Name
                                </th>

                                <th>
                                    Policy Number
                                </th>

                                <th>
                                    Policy Document
                                </th>

                                <th>
                                    Start Date
                                </th>

                                <th>
                                    End Date
                                </th>

                                <th>
                                    Premium
                                </th>

                                <th>
                                    GST
                                </th>

                                <th>
                                    Total Premium
                                </th>

                                <th>
                                    Remaining Balance
                                </th>

                                <th>
                                    Action
                                </th>

                            </tr>

                        </thead>

                        {/* TABLE BODY */}
                        <tbody>

                            {/* LOADING */}
                            {loadingPolicies ? (

                                <tr>

                                    <td
                                        colSpan="10"
                                        style={{
                                            textAlign:
                                                "center",
                                        }}
                                    >
                                        Loading
                                        policies...
                                    </td>

                                </tr>

                            ) : policies &&
                              policies.length >
                                  0 ? (

                                policies.map(
                                    (p) => (

                                        <tr
                                            key={
                                                p.policy_id
                                            }
                                        >

                                            {/* POLICY NAME */}
                                            <td>
                                                {p.policy_name ||
                                                    "—"}
                                            </td>

                                            {/* POLICY NUMBER */}
                                            <td>
                                                {p.policy_number ||
                                                    "—"}
                                            </td>

                                            {/* DOCUMENT */}
                                            <td>

                                                {p.policy_document ? (

                                                    <a
                                                        href={`/uploads/${p.policy_document}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        View
                                                        Document
                                                    </a>

                                                ) : (

                                                    "-"

                                                )}

                                            </td>

                                            {/* START DATE */}
                                            <td>

                                                {p.start_date
                                                    ? new Date(
                                                          p.start_date
                                                      ).toLocaleDateString()
                                                    : "—"}

                                            </td>

                                            {/* END DATE */}
                                            <td>

                                                {p.end_date
                                                    ? new Date(
                                                          p.end_date
                                                      ).toLocaleDateString()
                                                    : "—"}

                                            </td>

                                            {/* PREMIUM */}
                                            <td>

                                                {p.premium_amount ??
                                                    "—"}

                                            </td>

                                            {/* GST */}
                                            <td>

                                                {p.gst_amount ??
                                                    "—"}

                                            </td>

                                            {/* TOTAL PREMIUM */}
                                            <td>

                                                {p.total_premium ??
                                                    "—"}

                                            </td>

                                            {/* REMAINING BALANCE */}
                                            <td>

                                                {p.remaining_cd_balance ??
                                                    "—"}

                                            </td>

                                            {/* ACTIONS */}
                                            <td
                                                style={{
                                                    textAlign:
                                                        "center",

                                                    whiteSpace:
                                                        "nowrap",
                                                }}
                                            >

                                                {/* EDIT */}
                                                <FontAwesomeIcon
                                                    icon={
                                                        faEdit
                                                    }
                                                    style={{
                                                        color:
                                                            "#000",

                                                        cursor:
                                                            "pointer",

                                                        marginRight:
                                                            "15px",

                                                        fontSize:
                                                            "18px",
                                                    }}
                                                    title="Edit Policy"
                                                    onClick={() =>
                                                        handleEditPolicy(
                                                            p
                                                        )
                                                    }
                                                />

                                                {/* DELETE */}
                                                <FontAwesomeIcon
                                                    icon={
                                                        faTrash
                                                    }
                                                    style={{
                                                        color:
                                                            "red",

                                                        cursor:
                                                            "pointer",

                                                        fontSize:
                                                            "18px",
                                                    }}
                                                    title="Delete Policy"
                                                    onClick={() =>
                                                        handleDeletePolicy(
                                                            p.policy_id
                                                        )
                                                    }
                                                />

                                            </td>

                                        </tr>

                                    )
                                )

                            ) : (

                                <tr>

                                    <td
                                        colSpan="10"
                                        style={{
                                            textAlign:
                                                "center",
                                        }}
                                    >
                                        No policies
                                        found
                                    </td>

                                </tr>

                            )}

                        </tbody>

                    </table>

                </div>

                {/* FOOTER */}
                <Footer />

            </main>

        </div>
    );
}

export default PolicyList;